var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-avatar',{attrs:{"shape":_vm.$options.AVATAR_SHAPE_OPTION_RECT,"entity-id":_vm.entityId,"entity-name":_vm.projectName,"src":_vm.projectAvatarUrl,"alt":_vm.avatarAlt,"size":_vm.size,"fallback-on-error":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }